
export const environment = {
  production: false,
  APP_ID: '2f111e4b3f03c4f196c708bc43c33f8b',
  MY_API: 'AIzaSyCJ67H5QBLVTdO2pnmEmC2THDx95rWyC1g',
  POSITION_KEY: '26089ac1886b2def99aaddd358ce12e7',
  currentWeatherUrl : 'https://api.openweathermap.org/data/2.5/weather',
  weatherUrl : 'https://api.openweathermap.org/data/2.5/onecall',
  serverUrl:'http://192.168.100.4:3000',
  webpushPublicKey: 'BANj60N_R98P4eWU_G2WgM83M6s_ICURjYBsfYRNVZZxmtQXWh0gZcIY0JGs1CCKmR8DM2K8n_BRJStCEhVypLc'
};
